//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'birthdayWishes',
    data() {
        return {
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '规则名称',
                    align: 'center',
                    key: 'ruleName'
                },
                {
                    title: '会员姓名',
                    align: 'center',
                    key: 'memberName',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.memberName == null) {
                            return h('span', row.name);
                        } else {
                            return h('span', row.memberName);
                        }
                    }
                },
                {
                    title: '福利类型',
                    key: 'presentTypeStr', align: 'center'
                },
                {
                    title: '福利',
                    key: '',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.presentType == 0) {
                            return h('span', row.point + '积分');
                        } else {
                            return h('span', row.couponName);
                        }
                    }
                },
                {
                    title: '领取状态',
                    align: 'center',
                    key: 'receiveStatusStr'
                },
                {
                    title: '领取时间',
                    align: 'center',
                    key: 'receiveTimeStr'
                }
            ],
            list: [],
            totalCount: 0,
            pageSize: 20,
            currentPage: 1,
            searchInput: {},
            ruleId: 0
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getPage();
        },
        getPage() {
            this.searchInput.channelType = 0;
            this.searchInput.ruleId = this.ruleId;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/Birthday/SearchBirthdayNotices', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });

        }
    },
    created() {
        this.ruleId = parseInt(this.$route.params.ruleId) || 0;
        this.getPage();

    }
};
